/* eslint-disable import/prefer-default-export */
export const normalizeCustomFieldsFromOrder = (customAnswers = []) => {
  const customFieldsValues = {};
  const backendAnswers = [];

  customAnswers.forEach((ca) => {
    const { name } = ca.custom_field;
    const { kind } = ca.custom_field;
    let value = ca.answer;

    // Normalizar tipo
    if (['list', 'integer', 'float'].includes(kind)) value = String(value);
    if (kind === 'boolean') value = value === 'true';
    if (kind === 'date') value = value ? new Date(value) : undefined;

    customFieldsValues[name] = value;

    backendAnswers.push({
      id: ca.id,
      custom_field_id: ca.custom_field_id,
      answer: ca.answer
    });
  });

  return {
    customFieldsValues,
    backendAnswers
  };
};
